<div class="progress-container">
  <small>{{ value }}</small>
  <progress [value]="value" [max]="max"></progress>
</div>
